import $ from 'jquery';

export default class CommunitiesResources {
  constructor(element) {
    this.element = element;
    this.$element = $(this.element);
    this.init();
  }

  init() {
    setTimeout(() => {
      const $header = $(this.element.querySelector('.node-header'));
      const $image = $(this.element.querySelector('.dd-hover-dependencies .field-image'));
      if ($image.is('.field-video')) {
        const $href = $image.find('a').attr('href');
        $header
          .addClass('field-video')
          .find('a')
          .attr('href', $href)
          .prepend('<span class="video-play"></span>')
          .closest('.node')
          .addClass('play-video');
      }
    }, 100);
  }
}
